// Import components
import './completed-runs';
import './created-on';
import './throttle';
import './times-per-user';
import './total-times';
import './user-type';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-settings' )
export class AutomatorBuilderPublishSettings extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="publish-settings">
   				<uap-builder-publish-setting-throttle>
				</uap-builder-publish-setting-throttle>
	
				${ this._templateTimesPerUser }

				<uap-builder-publish-setting-total-times>
				</uap-builder-publish-setting-total-times>

				<uap-builder-publish-setting-user-type>
				</uap-builder-publish-setting-user-type>

				<uap-builder-publish-setting-created-on>
				</uap-builder-publish-setting-created-on>

				<uap-builder-publish-setting-completed-runs>
				</uap-builder-publish-setting-completed-runs>
			</div>
		`;
	}

	/**
	 * The times per user setting
	 *
	 * @return {TemplateResult|undefined} The times per user setting
	 */
	get _templateTimesPerUser() {
		// If the recipe is not a user recipe, do not show the times per user setting
		if ( UncannyAutomator._recipe.recipe_type != 'user' ) {
			return;
		}

		return html`
			<uap-builder-publish-setting-times-per-user>
			</uap-builder-publish-setting-times-per-user>
		`;
	}
}
